export default class {
	constructor(charts,echarts, xdata, seriesdata) { //echarts, id, xdata,seriesdata都是vue组件中传递过来的参数
		this.echarts = echarts;
		let option = this.getOption(xdata, seriesdata) //把参数传递给方法
		// var myChart = echarts.init(document.getElementById(id)); //获取dom
		charts.setOption(option); //暴露出去
		window.addEventListener("resize", function() {
			charts.resize();
		});
	}
	getOption(xdata, seriesdata) {
		// function fontSize(res) {
		// 	let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body
		// 		.clientWidth;
		// 	if (!clientWidth) return;
		// 	let fontSize = 100 * (clientWidth / 1920);
		// 	return res * fontSize;
		// }
		let option = {
			tooltip: {
				trigger: 'axis',
				axisPointer: {
					type: 'none',
				},
				formatter: function(parms) {
					// 循环处理数据，展示数据
					// console.log(parms)
					var htmlText = `<div style="width: 120px;height: 100px;">
						<div style='font-size:18px;color:#58acfa'>${parms[0].axisValueLabel}</div>
						<div>推荐职位：${parms[0].value}个</div>
						<div>推荐职位投递：${parms[1].value}个</div>
						<div>自主投递：${parms[2].value}个</div>
					</div>`
					return htmlText
				
				},
			},
			legend: {
				top: 'top',
				textStyle: {
					color: "#fff",
					fontSize: 14
				},
				itemGap: 20,
				itemWidth: 12,
				itemHeight: 12,
			},
			grid: {
				top: "15%",
				right: "2%",
				bottom: "0%",
				left: "2%",
				containLabel: true
			},
			xAxis: [{
				type: 'category',
				data: xdata,
				axisPointer: {
					type: 'shadow'
				},
				axisLine: {
					lineStyle: {
						color: "rgba(78, 202, 217, 0.4)"
					}
				},
				axisLabel: {
					interval: 0,
					textStyle: {
						fontSize: 14,
						color: '#fff',
					}
				},
			}],
			yAxis: [{
				type: 'value',
				name: '数量',
				axisLine: {
					show: true,
					lineStyle: {
						fontSize: 14,
						color: 'rgba(255,255,255,0)',
					}

				}, //左线色
				axisLabel: {
					textStyle: {
						color: '#fff',
						fontSize: 14,
					},
					formatter: '{value}'
				},
				splitLine: { //决定是否显示坐标中网格
					// show: false,
					lineStyle: {
						color: ['rgba(255,255,255,0.5)'],
						type: 'dot'
					}
				},
			}, ],
			series: [{
					name: '推荐职位',
					type: 'bar',
					tooltip: {
						valueFormatter: function(value) {
							return value;
						}
					},
					itemStyle: {
						normal: {
							//渐变色
							color: "#0098FA",
							label: {
								show: true, //开启显示
								position: 'top', //在上方显示
								textStyle: { //数值样式
									color: '#fff',
									fontSize: 14
								},
								formatter: function(val) {
									if (val.value > 0) {
										return val.value + '个'
									} else {
										return ''
									}
								},
							}
						}
					},
					data: seriesdata[0]
				},
				{
					name: '推荐职位投递',
					type: 'bar',
					tooltip: {
						valueFormatter: function(value) {
							return value;
						}
					},
					itemStyle: {
						normal: {
							//渐变色
							color: "#46C4D0",
							label: {
								show: true, //开启显示
								position: 'top', //在上方显示
								textStyle: { //数值样式
									color: '#fff',
									fontSize: 14
								},
								formatter: function(val) {
									if (val.value > 0) {
										return val.value + '个'
									} else {
										return ''
									}
								},
							}
						}
					},
					data: seriesdata[1]
				},
				{
					name: '自主投递',
					type: 'bar',
					tooltip: {
						valueFormatter: function(value) {
							return value;
						}
					},
					itemStyle: {
						normal: {
							//渐变色
							color: "#DB3BF4",
							label: {
								show: true, //开启显示
								position: 'top', //在上方显示
								textStyle: { //数值样式
									color: '#fff',
									fontSize: 14
								},
								formatter: function(val) {
									if (val.value > 0) {
										return val.value + '个'
									} else {
										return ''
									}
								},
							}
						}
					},
					data: seriesdata[2]
				}
			]
		};

		return option;
	}
}